<template>
  <b-container>
    <b-row>
      <b-col>
        <h4 class="subtitle">Start/End Dates</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="startdate mt-4">
          <label for="start_date">Start Date:</label>
            <datepicker
              class="text-center"
              name="start_date"
              :highlighted="highlighted"
              type="date"
              id="start_date"
              v-model="start_date"
            ></datepicker>
        </div>
      </b-col>
      <b-col>
        <div class="enddate mt-4">
          <label for="end_date">End Date:</label>
            <datepicker
              class="text-center"
              :highlighted="highlighted"
              name="end_date"
              type="date"
              id="end_date"
              v-model="end_date"
            ></datepicker>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'GroupDates',
  components: {
    Datepicker,
  },
  data() {
    return {
      highlighted: {
        dates: [
          new Date(),
        ]
      },
    };
  },
  computed: {
    start_date: {
      get() {
        const date = this.$store.state.groups.group.start_date;
        return date;      
      },
      set(val) {
        this.$store.commit(`groups/start_date`, val);
      }
    },
    end_date: {
      get() {
        const date = this.$store.state.groups.group.end_date;
        return date;      
      },
      set(val) {
        this.$store.commit(`groups/end_date`, val);
      }
    },
  },
};
</script>
